<template>
  <el-dialog
    :title="$t('parkingAreaManage.detailTitle')"
    :visible.sync="visible"
    width="600px"
    @close="closeDialog"
  >
    <el-descriptions :column="2" border v-loading="loading">
      <el-descriptions-item :label="$t('parkingAreaManage.parkingId')">{{ parkingArea.paId }}</el-descriptions-item>
      <el-descriptions-item :label="$t('parkingAreaManage.parkingNum')">{{ parkingArea.num }}</el-descriptions-item>
      <el-descriptions-item :label="$t('parkingAreaManage.parkingType')">
        {{ parkingArea.typeCd === '1001' ? $t('parkingAreaManage.aboveGround') : $t('parkingAreaManage.underground') }}
      </el-descriptions-item>
      <el-descriptions-item :label="$t('parkingAreaManage.publicSpaceCount')">{{ parkingArea.publicSpaceCount }}</el-descriptions-item>
      <el-descriptions-item :label="$t('parkingAreaManage.innerCarUsePublic')">
        {{ parkingArea.innerCarUsePublic === 'Y' ? $t('common.yes') : $t('common.no') }}
      </el-descriptions-item>
      <el-descriptions-item :label="$t('parkingAreaManage.multiCarInType')">
        {{ viewMultiCarInType(parkingArea.multiCarInType) }}
      </el-descriptions-item>
      <el-descriptions-item :label="$t('parkingAreaManage.remark')" :span="2">{{ parkingArea.remark }}</el-descriptions-item>
    </el-descriptions>

    <div v-if="showSpaceInfo" class="space-info" style="margin-top: 20px;">
      <el-divider></el-divider>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-card shadow="hover" class="text-center">
            <div class="stat-value" style="font-size: 28px; color: #409EFF;">{{ spaceInfo.monthCarCount }}</div>
            <div class="stat-label" style="margin-top: 8px; color: #606266;">{{ $t('parkingAreaManage.monthCarCount') }}</div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card shadow="hover" class="text-center">
            <div class="stat-value" style="font-size: 28px; color: #67C23A;">{{ spaceInfo.tempCarInCount }}</div>
            <div class="stat-label" style="margin-top: 8px; color: #606266;">{{ $t('parkingAreaManage.tempCarInCount') }}</div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import { getParkingAreaSpaceInfo } from '@/api/car/parkingAreaManageApi'

export default {
  name: 'ParkingAreaDetail',
  data() {
    return {
      visible: false,
      loading: false,
      parkingArea: {
        paId: '',
        num: '',
        typeCd: '',
        publicSpaceCount: 0,
        innerCarUsePublic: 'N',
        multiCarInType: '0',
        multiCarInMsg: '',
        remark: ''
      },
      spaceInfo: {
        monthCarCount: 0,
        tempCarInCount: 0
      }
    }
  },
  computed: {
    showSpaceInfo() {
      return this.parkingArea.publicSpaceCount > 0
    }
  },
  methods: {
    open(row) {
      this.visible = true
      this.parkingArea = { ...row }
      this.spaceInfo = {
        monthCarCount: 0,
        tempCarInCount: 0
      }
      if (this.showSpaceInfo) {
        this._loadSpaceInfo(row.paId)
      }
    },

    closeDialog() {
      this.parkingArea = {
        paId: '',
        num: '',
        typeCd: '',
        publicSpaceCount: 0,
        innerCarUsePublic: 'N',
        multiCarInType: '0',
        multiCarInMsg: '',
        remark: ''
      }
      this.spaceInfo = {
        monthCarCount: 0,
        tempCarInCount: 0
      }
    },

    async _loadSpaceInfo(paId) {
      this.loading = true
      try {
        const res = await getParkingAreaSpaceInfo(paId)
        this.spaceInfo.monthCarCount = res.data.monthCarCount || 0
        this.spaceInfo.tempCarInCount = res.data.tempCarInCount || 0
      } catch (error) {
        console.error('获取停车场车位统计失败:', error)
        this.$message.error(this.$t('parkingAreaManage.fetchSpaceInfoError'))
      } finally {
        this.loading = false
      }
    },

    viewMultiCarInType(multiCarInType) {
      if (multiCarInType === '2') return this.$t('parkingAreaManage.multiCarInTypeAllow')
      return this.$t('parkingAreaManage.multiCarInTypeForbid')
    }
  }
}
</script>
